import dayjs from "dayjs";
import { Typography } from "@mui/joy";
import {
  IonCard,
  IonCardContent,
  IonCol,
  IonGrid,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonRow,
} from "@ionic/react";
import { callSharp, logoWhatsapp } from "ionicons/icons";
import CustomDesplegable from "../../components/basicsComponents/CustomDesplegable/CustomDesplegable";
import StyledButton from "../../components/basicsComponents/StyledButton/StyledButton";
import CustomToast from "../../components/basicsComponents/CustomToast/CustomToast";
import { DialogoConfirmacion } from "../../components/basicsComponents/DialogoConfirmacion/DialogoConfirmacion";
import LoadingBackdrop from "../../components/basicsComponents/LoadingBackdrop/LoadingBackdrop";
import {
  Column,
  Container,
  Row,
} from "../../components/basicsComponents/MaterialGridComponents";
import CustomCalendar from "../../components/basicsComponents/Calendar";
import { obtenerNombreDia } from "../../utils/funcionalidadesStrings";
import useTituloPagina from "../../hooks/tituloPagina";
import { useNuevoTurnoImagenes } from "./useNuevoTurnoImagenes";

import React, { useState } from "react";

function NuevoTurnoImagenes() {
  useTituloPagina();
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastColor, setToastColor] = useState("");

  const mostrarNotificacion = (open, mensaje, color) => {
    setOpenToast(open);
    setToastMessage(mensaje);
    setToastColor(color);
  };

  const {
    cargando,
    estudiosDesplegable,
    prestadoresDesplegable,
    estudioSeleccionado,
    prestadorSeleccionado,
    fechasFuturas,
    fechaSeleccionada,
    turnosDisponibles,
    turnoSeleccionado,
    notaWebMutual,
    mostrarInasisEstudio,
    mostrarTurnoPrestadorReservado,
    abrirDesplegableEstudios,
    abrirDesplegablePrestadores,
    abrirModalConfirmarReserva,
    abrirModalPostReserva,
    setAbrirDesplegableEstudios,
    setAbrirDesplegablePrestadores,
    setAbrirModalConfirmarReserva,
    setAbrirModalPostReserva,
    handleChangeSelect,
    handleChangeFecha,
    handleClickSeleccionarTurno,
    handleClickConfirmarHacerReserva,
    handleClickCopiarTelefono,
    handlePostTurnoReservado,
    renderTurnos,
    getPrestadorSeleccionadoData,
  } = useNuevoTurnoImagenes(mostrarNotificacion);

  const prestadorData = getPrestadorSeleccionadoData();
  const notaWebPrestador = (
    prestadorData?.notaWeb ||
    prestadorData?.NotaWeb ||
    ""
  ).trim();

  return (
    <>
      <div slot="content">
        <Container>
          <Row container width="100%">
            <Column xs={12} md={6}>
              <IonItem className="ion-item-no-border">
                <CustomDesplegable
                  cargando={cargando}
                  array={estudiosDesplegable}
                  value={estudioSeleccionado}
                  handleChange={handleChangeSelect}
                  mostrarTodos={false}
                  mostrarSearch={true}
                  placeholder="Seleccione un estudio..."
                  label="Estudios"
                  id="Estudio"
                  isOpen={abrirDesplegableEstudios}
                  setIsOpen={setAbrirDesplegableEstudios}
                  variant="plain"
                  disabled={cargando}
                />
              </IonItem>
            </Column>
            {estudioSeleccionado !== -1 && (
              <Column xs={12} md={6}>
                <IonItem className="ion-item-no-border">
                  <CustomDesplegable
                    cargando={cargando}
                    array={prestadoresDesplegable}
                    value={prestadorSeleccionado}
                    handleChange={handleChangeSelect}
                    mostrarTodos={false}
                    mostrarSearch={true}
                    placeholder="Seleccione un profesional..."
                    label="Profesionales"
                    id="Profesional"
                    isOpen={abrirDesplegablePrestadores}
                    setIsOpen={setAbrirDesplegablePrestadores}
                    variant="plain"
                    disabled={cargando || estudioSeleccionado === -1}
                  />
                </IonItem>
              </Column>
            )}
          </Row>
        </Container>
        {estudioSeleccionado !== -1 &&
          prestadorSeleccionado !== -1 &&
          notaWebPrestador && (
            <Container>
              <Row container width="100%" style={{ marginBottom: "16px" }}>
                <Column xs={12}>
                  <div
                    style={{
                      maxWidth: "960px",
                      margin: "0 auto",
                      padding: "0 8px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        borderRadius: "14px",
                        padding:
                          window.innerWidth < 768 ? "12px 14px" : "14px 18px",
                        background:
                          "linear-gradient(135deg, rgba(58, 61, 153, 0.94) 0%, rgba(81, 83, 179, 0.94) 100%)",
                        boxShadow: "0 8px 22px rgba(58, 61, 153, 0.20)",
                        color: "#fff",
                        fontWeight: 600,
                        fontSize: window.innerWidth < 768 ? "0.92rem" : "1rem",
                        lineHeight: 1.45,
                      }}
                    >
                      {notaWebPrestador}
                    </div>
                  </div>
                </Column>
              </Row>
            </Container>
          )}
        {estudioSeleccionado !== -1 &&
          prestadorSeleccionado !== -1 &&
          notaWebMutual && (
            <Container>
              <Row container width="100%" style={{ marginBottom: "16px" }}>
                <Column xs={12}>
                  <div
                    style={{
                      maxWidth: "960px",
                      margin: "0 auto",
                      padding: "0 8px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        borderRadius: "14px",
                        padding:
                          window.innerWidth < 768 ? "12px 14px" : "14px 18px",
                        background:
                          "linear-gradient(135deg, rgba(254, 80, 108, 0.92) 0%, rgba(255, 134, 153, 0.92) 100%)",
                        boxShadow: "0 8px 22px rgba(254, 80, 108, 0.22)",
                        color: "#fff",
                        fontWeight: 600,
                        fontSize: window.innerWidth < 768 ? "0.92rem" : "1rem",
                        lineHeight: 1.45,
                      }}
                    >
                      {notaWebMutual}
                    </div>
                  </div>
                </Column>
              </Row>
            </Container>
          )}
        {fechasFuturas.length > 0 && (
          <IonGrid>
            <IonRow>
              <IonCol>
                <CustomCalendar
                  onChange={(newSelectedDate) =>
                    handleChangeFecha(
                      dayjs(newSelectedDate).format("YYYY-MM-DD"),
                    )
                  }
                  minDate={dayjs(new dayjs())}
                  maxDate={dayjs(new dayjs()).add(3, "months")}
                  value={fechaSeleccionada}
                  highlightedDates={fechasFuturas}
                />
              </IonCol>
              {turnosDisponibles.length > 0 && (
                <IonCol>
                  <IonList lines="none">
                    <IonListHeader>
                      <Typography
                        level="body-md"
                        sx={{ color: prestadorData.note2Color }}
                        color={prestadorData.note2Color}
                      >
                        {`${obtenerNombreDia(dayjs(fechaSeleccionada).format("dddd"))} ${dayjs(fechaSeleccionada).format("DD")} de ${dayjs(fechaSeleccionada).format("MMMM, YYYY")} - Horarios disponibles${prestadorData.mutual === 1 ? " (Particular)" : ""}`}
                      </Typography>
                    </IonListHeader>
                    <IonGrid>
                      <IonRow>{renderTurnos()}</IonRow>
                    </IonGrid>
                  </IonList>
                </IonCol>
              )}
            </IonRow>
          </IonGrid>
        )}
      </div>
      {mostrarInasisEstudio && (
        <IonRow className="ion-justify-content-center">
          <IonCol>
            <IonCard color="warning">
              <IonCardContent>
                <h4 className="main-content">
                  ⚠ No podes reservar un nuevo turno con este estudio debido a
                  que no asististe a 2 o más turnos en los últimos 2 meses para
                  el estudio que seleccionaste. Estaremos encantados de
                  atenderte y brindarte la mejor atención personalizada si te
                  pones en contacto. Podes presionar los botones inferiores para
                  copiar el número de teléfono fijo o llevarte a nuestro chat de
                  Whatsapp.
                </h4>
              </IonCardContent>
              <IonRow>
                <IonCol>
                  <StyledButton className="verde" expand="block">
                    <IonIcon icon={logoWhatsapp} />
                    <IonLabel>WhatsApp</IonLabel>
                  </StyledButton>
                </IonCol>
                <IonCol>
                  <StyledButton
                    className="blanco"
                    expand="block"
                    onClick={handleClickCopiarTelefono}
                  >
                    <IonIcon icon={callSharp} />
                    <IonLabel>Teléfono</IonLabel>
                  </StyledButton>
                </IonCol>
              </IonRow>
            </IonCard>
          </IonCol>
        </IonRow>
      )}
      {mostrarTurnoPrestadorReservado && (
        <IonRow className="ion-justify-content-center">
          <IonCol>
            <IonCard color="warning">
              <IonCardContent>
                <h4 className="main-content">
                  ⚠ No está permitido sacar un segundo turno para un mismo
                  prestador
                </h4>
              </IonCardContent>
            </IonCard>
          </IonCol>
        </IonRow>
      )}
      {prestadorSeleccionado !== -1 && (
        <DialogoConfirmacion
          titulo="Reservar turno"
          texto={`Ha seleccionado el turno${prestadorData.mutual === 1 ? " de atención PARTICULAR" : ""} con el/la profesional ${turnoSeleccionado.prestadorNom}, para el estudio ${turnoSeleccionado.estudioNom}, para el día ${dayjs(turnoSeleccionado.fecha).format("DD/MM/YYYY")}, a las ${dayjs(turnoSeleccionado.hora).format("HH:mm")}${prestadorData.mutual === 1 ? " particular" : ""}, ¿es esto correcto?`}
          open={abrirModalConfirmarReserva}
          setOpen={setAbrirModalConfirmarReserva}
          handleClickConfirmar={handleClickConfirmarHacerReserva}
          colorBotonNo="danger"
          colorBotonSi="success"
          textoBotonNo="No, Revisar"
          textoBotonSi="Si, Confirmar"
        />
      )}
      {prestadorSeleccionado !== -1 && (
        <DialogoConfirmacion
          titulo="Turno reservado"
          texto={`Se ha reservado exitosamente el turno${prestadorData.mutual === 1 ? " particular" : ""} con el/la profesional ${turnoSeleccionado.prestadorNom}, para el estudio ${turnoSeleccionado.estudioNom}, para el día ${dayjs(turnoSeleccionado.fecha).format("DD/MM/YYYY")}, a las ${dayjs(turnoSeleccionado.hora).format("HH:mm")}`}
          open={abrirModalPostReserva}
          setOpen={setAbrirModalPostReserva}
          handleClickConfirmar={() => handlePostTurnoReservado("nuevoTurno")}
          handleClickCancelar={() => handlePostTurnoReservado("turnosPaciente")}
          variantBotonNo="solid"
          colorBotonNo="primary"
          variantBotonSi="solid"
          colorBotonSi="primary"
          variantDialog="plain"
          colorDialogo="success"
          textoBotonNo="Consultar mis turnos"
          textoBotonSi="Reservar nuevo turno"
        />
      )}
      {cargando && <LoadingBackdrop visualizar={cargando} />}
      <CustomToast
        openToast={openToast}
        onDidDismiss={() => setOpenToast(false)}
        message={toastMessage}
        colorNotificacion={toastColor}
      />
    </>
  );
}

export default NuevoTurnoImagenes;
